<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  
// Move Size chart link to Size chart start
const interval = setInterval(() => {
    const targetDivs = document.querySelectorAll('div[data-unique="_wftq5137k"]');
    const movingDiv = document.querySelector('.productView-sizeChart');

    if (!movingDiv) {
       // console.log("Waiting for .productView-sizeChart...");
        return;
    }

    targetDivs.forEach(targetDiv => {
        const labelElement = Array.from(targetDiv.querySelectorAll('label'))
            .find(label => label.querySelector('span')?.textContent.trim() === "STANDARD SIZE:");

        if (labelElement) {
            //console.log("Found target label! Moving .productView-sizeChart...");
            labelElement.insertAdjacentElement('afterend', movingDiv);
            clearInterval(interval); // Stop checking once moved
        }
    });
}, 500); 
// Move Size chart link to Size chart End

document.addEventListener("DOMContentLoaded", function () {
  // Only run the accordion logic if screen width >= 551px
  if (window.innerWidth >= 551) {

    setTimeout(function() {
      document.querySelectorAll("a.tab-title").forEach(function(el) {
        if (el.style.getPropertyValue("--border-color")) {
          el.style.removeProperty("--border-color");
        }
      });
    }, 200);


    var tabsContainer = document.querySelector(".tabs");
    if (!tabsContainer) return;

    // Get all tab <li> items
    var tabItems = tabsContainer.querySelectorAll("li.tab");

    // Move associated content after each tab & set up classes
    tabItems.forEach(function (tab) {
      var link = tab.querySelector("a.tab-title");
      if (link) {
        var contentId = link.getAttribute("href"); // e.g. "#tab-product-details"
        var contentDiv = document.querySelector(contentId);
        if (contentDiv) {
          // Move the contentDiv after the tab
          tab.insertAdjacentElement("afterend", contentDiv);
          // Remove conflicting classes
          contentDiv.classList.remove("is-active", "active");
          // Add our custom class
          contentDiv.classList.add("my-tab-content");
          // Hide initially
          contentDiv.classList.remove("visible");
        }
      }
    });

    // Accordion click events
    tabItems.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var contentDiv = tab.nextElementSibling;
        if (contentDiv && contentDiv.classList.contains("my-tab-content")) {
          if (contentDiv.classList.contains("visible")) {
            // Collapse if open
            contentDiv.classList.remove("visible");
            tab.classList.remove("active");
          } else {
            // Collapse all panels first
            document.querySelectorAll(".my-tab-content").forEach(function (div) {
              div.classList.remove("visible");
            });
            tabItems.forEach(function (t) {
              t.classList.remove("active");
            });
            // Expand the clicked tab’s content
            contentDiv.classList.add("visible");
            tab.classList.add("active");
          }
        }
      });
    });
  }
});

/* size options below table product page */

function applyTableStyles() {
    var table = document.getElementById("custom-size-table");

    if (table) {
        console.log("Table found! Applying styles...");

        table.style.width = "100%";
        table.style.borderCollapse = "separate";
        table.style.borderSpacing = "5px";
        table.style.backgroundColor = "#f6f3e9";

        var cells = table.getElementsByTagName("td");
        for (var i = 0; i < cells.length; i++) {
            cells[i].style.padding = "10px";
            cells[i].style.textAlign = "center";
            cells[i].style.fontSize = "18px";
            cells[i].style.borderRadius = "5px";

            // Apply different colors for header and body rows
            if (cells[i].parentNode.rowIndex === 0) {
                cells[i].style.fontWeight = "bold";
                cells[i].style.backgroundColor = "#e8e4d9";
            } else {
                cells[i].style.backgroundColor = "#f0eee0";
            }
        }
        console.log("Styling applied successfully!");
        return true; // Return true when styles are applied
    } else {
        console.log("Table not found yet, retrying...");
    }
    return false; // Return false if table is not found
}

// Use setInterval to keep checking if the table is loaded
var checkTable = setInterval(function () {
    //console.log("Checking for table...");
    //if (applyTableStyles()) {
    //    clearInterval(checkTable); // Stop checking once table is styled
    //    console.log("Stopping interval, styles applied.");
   // }
}, 100); // Check every 500ms



/* Size chart page js */

   document.addEventListener("DOMContentLoaded", function () {
        const buttons = document.querySelectorAll(".dsi_htm_tabs .bl");
        const contents = document.querySelectorAll(".dsi_content > div");

        buttons.forEach((button, index) => {
          button.addEventListener("click", function () {
            // Remove 'active' class from all buttons
            buttons.forEach((btn) => btn.classList.remove("active"));

            // Hide all content divs
            contents.forEach((content) => (content.style.display = "none"));

            // Add 'active' class to clicked button
            button.classList.add("active");

            // Show corresponding content
            contents[index].style.display = "block";
          });
        });
      });

 document.addEventListener("DOMContentLoaded", function () {
    // Main tabs
    const mainTabs = document.querySelectorAll(".dsi_tabs button");
    const sizeChart = document.querySelector(".dsi_sc");
    const howToMeasure = document.querySelector(".dsi_htm");

    // Ensure Size Chart is shown by default
    sizeChart.style.display = "block";
    howToMeasure.style.display = "none";
    mainTabs[0].classList.add("active");

    mainTabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        // Remove active class from all tabs
        mainTabs.forEach((t) => t.classList.remove("active"));

        // Hide both sections
        sizeChart.style.display = "none";
        howToMeasure.style.display = "none";

        // Show the selected section
        if (index === 0) {
          sizeChart.style.display = "block";
        } else {
          howToMeasure.style.display = "block";
        }

        // Add active class to clicked tab
        this.classList.add("active");
      });
    });

    // Sub-tabs for "How to Measure"
    const subTabs = document.querySelectorAll(".dsi_htm_tabs button");
    const subContentSections = document.querySelectorAll(".dsi_content > div");

    // Ensure the first sub-tab is active by default
    subTabs[0].classList.add("active");
    subContentSections.forEach((section, index) => {
      section.style.display = index === 0 ? "block" : "none";
    });

    subTabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        // Remove active class from all sub-tabs
        subTabs.forEach((t) => t.classList.remove("active"));
        // Hide all sub-content sections
        subContentSections.forEach(
          (section) => (section.style.display = "none")
        );

        // Show the selected sub-content
        subContentSections[index].style.display = "block";
        this.classList.add("active");
      });
    });
  });

 document.addEventListener("DOMContentLoaded", function () {
    // Select mobile tab buttons and content sections within the mobile container
    const mobileTabs = document.querySelectorAll(
      ".page-mobile .dsi_htm_tabs .tab"
    );
    const mobileContentSections = document.querySelectorAll(
      ".page-mobile .dsi_content > div"
    );

    // Set initial active state if available
    if (mobileTabs.length > 0 && mobileContentSections.length > 0) {
      mobileTabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
          mobileTabs.forEach((t) => t.classList.remove("active"));
          mobileContentSections.forEach(
            (section) => (section.style.display = "none")
          );
          tab.classList.add("active");
          mobileContentSections[index].style.display = "block";
        });
      });
    }

    // Get the switch container and inner dot element
    const switchEl = document.querySelector(".s-wrap .switch");
    const dotEl = switchEl.querySelector(".dot");

    // Get the table containers
    const inchTables = document.querySelector(".inch-tables");
    const cmTables = document.querySelector(".cm-tables");

    // Set default state (inch selected)
    dotEl.style.left = "0px";
    inchTables.style.display = "block";
    cmTables.style.display = "none";

    switchEl.addEventListener("click", function () {
      // Toggle based on current dot position
      console.log('sasa')
      if (dotEl.style.left === "0px") {
        // Change to cm
        dotEl.style.left = "24px"; // 42px (container width) - 18px (dot width) = 24px
        inchTables.style.display = "none";
        cmTables.style.display = "block";
      } else {
        // Change to inch
        dotEl.style.left = "0px";
        inchTables.style.display = "block";
        cmTables.style.display = "none";
      }
    });
  });

 // select tabs
  function resetActiveTabs() {
    if (window.innerWidth <= 768) {
      // Mobile is visible
      const mobileTabs = document.querySelectorAll(
        ".page-mobile .dsi_htm_tabs .tab"
      );
      const mobileContents = document.querySelectorAll(
        ".page-mobile .dsi_content > div"
      );
      mobileTabs.forEach((tab) => tab.classList.remove("active"));
      if (mobileTabs.length > 0) {
        mobileTabs[0].classList.add("active");
      }
      mobileContents.forEach((section, index) => {
        section.style.display = index === 0 ? "block" : "none";
      });
    } else {
      // Desktop is visible
      const desktopTabs = document.querySelectorAll(".dsi_htm_tabs button");
      const desktopContents = document.querySelectorAll(".dsi_content > div");
      desktopTabs.forEach((tab) => tab.classList.remove("active"));
      if (desktopTabs.length > 0) {
        desktopTabs[0].classList.add("active");
      }
      desktopContents.forEach((section, index) => {
        section.style.display = index === 0 ? "block" : "none";
      });
    }
  }

  document.addEventListener("DOMContentLoaded", resetActiveTabs);
  window.addEventListener("resize", resetActiveTabs);

  // Run on page load
  document.addEventListener("DOMContentLoaded", function () {
    handleResponsiveDisplay();

    // Run when window is resized
    window.addEventListener("resize", handleResponsiveDisplay);

    // Your existing DOMContentLoaded code here...
  });





